export const cardBlocking = {
    unblockingBox: true,
};
